module.exports = __webpack_public_path__ + "img/흐리고한때소나기.338ada3a.png";